import { InjectionToken } from '@angular/core';
import { IChemotherapyService } from './chemotherapy-service.interface';

export const CHEMOTHERAPY_SERVICE =
  new InjectionToken<IChemotherapyService>('CHEMOTHERAPY_SERVICE');
